import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import React from 'react';
import { createSelector } from 'reselect';
import CloseIcon from '@material-ui/icons/Close';
import Input from '@material-ui/core/Input';
import FlowmeterFilterButton from '../../button/FlowmeterFilterButton';

interface IFlowmeterFilterSelectorProps {
    id ?: string;
    fullWidth ?: boolean;
    required ?: boolean;

    label : string;
    disabled ?: boolean;

    code : string | null;
    name : string | null;
    division : string | null;
    manArea : string | null;

    onChange ?: (name : string | null, code : string | null, division : string | null, manArea : string | null) => void;
}

interface IFlowmeterFilterSelectorState {
    open : boolean;
}

export default class FlowmeterFilterSelector extends React.PureComponent<IFlowmeterFilterSelectorProps, IFlowmeterFilterSelectorState> {
    constructor(props : IFlowmeterFilterSelectorProps) {
        super(props);
        this.state = {
            open: false,
        };
    }

    private readonly onFilterIconButtonClick = () => {
        this.toggleOpen(!this.state.open);
    };

    private readonly onFilterFocusClick = () => {
        this.toggleOpen(true);
    };

    private readonly onClearClick = () => {
        this.onChange(null, null, null, null);
    };

    public readonly onChange = (name : string | null, code : string | null, division : string | null, manArea : string | null) => {
        this.setState({
            open: false,
        });

        if (!this.props.onChange) return;
        this.props.onChange(name, code, division, manArea);

    };

    private readonly toggleOpen = (open : boolean) => {
        this.setState({
            open,
        });
    };

    private readonly getName = (props : IFlowmeterFilterSelectorProps) => props.name;
    private readonly getCode = (props : IFlowmeterFilterSelectorProps) => props.code;
    private readonly getDivision = (props : IFlowmeterFilterSelectorProps) => props.division;
    private readonly getManArea = (props : IFlowmeterFilterSelectorProps) => props.manArea;

    private readonly getLabel = createSelector(
        [this.getName, this.getCode, this.getDivision, this.getManArea],
        (name, code, division, manArea) => {
            const result = [];

            if (name) result.push(name);
            if (code) result.push(code);
            if (division) result.push(division);
            if (manArea) result.push(manArea);

            return result.join(' - ');
        },
    );

    public render = () => {
        const { required, fullWidth, label, id, code, name, division, manArea, disabled } = this.props;
        const { open } = this.state;

        const value = this.getLabel(this.props);
        return (
            <FormControl fullWidth={fullWidth} error={required && !code} required={required}>
                <InputLabel htmlFor={id}>{label}</InputLabel>
                <Input
                    onFocus={this.onFilterFocusClick}
                    onChange={undefined}
                    value={value}
                    readOnly
                    endAdornment={
                        <InputAdornment position='end'>
                            {
                                (code || name || division || manArea) &&
                                <IconButton
                                    aria-label='clear filter'
                                    onClick={this.onClearClick}
                                >
                                    <CloseIcon className='cr' />
                                </IconButton>
                            }
                            <FlowmeterFilterButton
                                color='primary'
                                id='Flowmeters_filter'
                                open={open}
                                onClick={this.onFilterIconButtonClick}
                                onChange={this.onChange}
                                name={name}
                                code={code}
                                division={division}
                                manArea={manArea}
                                disabled={disabled}
                            />
                        </InputAdornment>
                    }
                />
            </FormControl>
        );
    };
}
